import React from "react";
import { Button } from "react-bootstrap";
import { DepartmentEdit } from ".";
import { DisplayBox } from "../../components";
import { ApiHelper, DepartmentInterface, UserHelper } from "../../helpers";
import { Permissions } from "./Permissions"

interface Props {

}

export const Departments: React.FC<Props> = props => {

  const [departments, setDepartments] = React.useState<DepartmentInterface[]>(null);
  const [selectedDepartment, setSelectedDepartment] = React.useState<DepartmentInterface>(null);
  const [permissionsDepartment, setPermissionsDepartment] = React.useState<DepartmentInterface>(null);


  const init = () => {
    if (UserHelper.checkAccess("owner") || UserHelper.checkAccess("admin")) {
      ApiHelper.get<DepartmentInterface[]>("/departments").then((data) => setDepartments(data || []));
      setSelectedDepartment(null);
      setPermissionsDepartment(null);
    }
  }

  React.useEffect(init, [])

  const getDepartmentRows = () => {
    const result: React.ReactElement[] = [];
    departments?.forEach(d => {
      const department = d;
      result.push(<tr>
        <td>{d.name}</td>
        <td style={{ textAlign: "right" }}>
          <Button size="sm" variant="success" onClick={(e) => { e.preventDefault(); setSelectedDepartment(department); }} >Edit</Button> &nbsp;
          <Button size="sm" variant="info" onClick={(e) => { e.preventDefault(); setPermissionsDepartment(department); }}>Permissions</Button>
        </td>
      </tr>)
    })
    return result;
  }

  const addDepartment = (e: React.MouseEvent) => {
    e.preventDefault();
    setSelectedDepartment({ accountId: UserHelper.currentDepartment.accountId, name: "New Department" })
  }

  const getNewButton = () => {
    return <Button size="sm" variant="success" onClick={addDepartment} ><i className="fas fa-users" style={{ color: "#FFF" }}></i> New</Button>
  }

  const getPermissions = () => {
    if (permissionsDepartment) return <Permissions department={permissionsDepartment} />
  }


  if (!UserHelper.checkAccess("owner") && !UserHelper.checkAccess("admin")) return <></>
  else if (selectedDepartment) return <DepartmentEdit department={selectedDepartment} onDone={init} />
  else {
    return (
      <>
        <DisplayBox headerText="Departments" headerIcon="fas fa-users" editContent={getNewButton()}  >
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th className="text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                {getDepartmentRows()}
              </tbody>
            </table>
          </div>
        </DisplayBox>
        {getPermissions()}

      </>
    );
  }

};